export const GOOGLE_BANNER_IMG_URL =
  '//static.parastorage.com/services/santa-resources/resources/viewer/addressInput/powered_by_google_on_white.png';

export const testIds = {
  suggestions: 'suggestions',
  label: 'label',
};

export const ariaNamespace = 'Address_Input';
